import { DateUtil } from '../../../utils';

// Past History config
export const historyDataConfig = [
  {
    label: 'Claim No',
    key: 'ClaimNo',
  },
  {
    label: 'Claim Date',
    key: 'Claim Date',
    render: item =>
      new Date(item?.['Claim Date']).toLocaleDateString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      }),
  },
  { label: 'Expense Curr', key: 'ExpenseCurr' },
  { label: 'Amount', key: 'Amt' },
  { label: 'Remarks', key: 'Remarks' },
  { label: 'SORNo', key: 'SORNo' },
  { label: 'Claim Status', key: 'ClaimStatus' },
];

export const mainFieldKeys = [
  'expCategory',
  'expType',
  'expDate',
  'currency',
  'amount',
  'taxAmount',
  'expRate',
  'remarks',
];

export const approvalDataConfig = [
  {
    label: 'Approver',
    key: 'Approver',
  },
  {
    label: 'Status',
    key: 'Status',
  },
  {
    label: 'Date',
    key: 'Date',
    render: item => DateUtil.formatISOToDateAndTime(item?.Date) || '-',
  },
  { label: 'Comments', key: 'Comments' },
];
